var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.usps.length)?_c('div',{staticClass:"flex flex-col md:flex-row relative w-full"},_vm._l((_vm.usps),function(usp,index){return _c('usps',{key:index,class:[
      'text-center md:text-length md:pe-4 lg:pe-6',
      index === _vm.defaultUsps ? '' : 'hidden md:flex',
    ],attrs:{"text":usp.text,"tabindex":"0"}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }